<div class="vl-region">
    <div class="vl-layout vl-layout--wide">
        <div class="vl-grid vl-grid--is-stacked">
            <div class="vl-col--9-12 vl-col--9-12--m vl-col--12-12--s vl-col--1-1--xs">

                <h2 class="vl-title vl-title--h2">
                    {{'TITEL' | translate}}
                </h2>

                <!-- Begin Content  -->
                <div class="vl-alert vl-alert--error" role="alert">
                    <div class="vl-alert__icon">
                        <i class="vl-vi vl-vi-warning" aria-hidden="true"></i>
                    </div>
                    <div class="vl-alert__content">
                        <div class="vl-alert__message">
                            <p>{{'ERROR_HTTP.403' | translate}}</p>
                        </div>
                    </div>
                </div>

                <!-- End Content -->

            </div>
            <div class="vl-col--3-12 vl-col--3-12--m vl-col--12-12--s vl-col--1-1--xs">
                <!-- Begin Side navigation -->

                <!-- End Side navigation -->
            </div>
        </div>
    </div>
</div>